module.exports = __webpack_public_path__ + "img/lg_ring_g_l_null_null@3x.76f19865.png";